import React from 'react';

import BaseAlertRoot from 'containers/BaseAlertRoot';
import eventTypes from 'constants/eventTypes';
import { BANNER_TEMPLATE_COMPONENT_MAP } from 'templateComponentMap';
import { BANNER_ROOT_INIT_FUNCTION_MAP } from 'rootInitFunctionMap';
import alertTypes from 'api/constants/alertTypes';

const BannerAlertRoot = () => (
  <BaseAlertRoot
    templateComponentMap={BANNER_TEMPLATE_COMPONENT_MAP}
    templateCallbackMap={BANNER_ROOT_INIT_FUNCTION_MAP}
    alertType={alertTypes.BANNER}
    eventType={eventTypes.SHOW_BANNER}
  />
);

export default BannerAlertRoot;
